import { Component, OnInit } from '@angular/core';
import { StorageService } from '../../../services/storage.service';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { navItemKey, BulkItemOptions, InteractionTypeModel, MultiDeviceInteractionState } from '../../../models/consumer/consumer-interaction.model';
import { ClaimsService } from '../../../services/claims.service';
import { MultiDeviceInteractionService } from '../../../services/multi-device-interaction.service';
import swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'multi-device-what',
    templateUrl: './multi-device-what.component.html',
    styles: []
})
export class MultiDeviceWhatComponent implements OnInit {

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private fb: UntypedFormBuilder,
        private storageService: StorageService,
        private claimsService: ClaimsService,
        private multiDeviceInteractionService: MultiDeviceInteractionService
    ) { }

    subscriptions: any[] = [];
    navigationList: any[] = [];
    OptionItemList: any[] = [];
    selectedNavItem: navItemKey = navItemKey.Account;
    isSuperUser:   boolean = false;
    isPayg:        boolean = false;
    isPaygUpdate:  boolean = false;
    isBilling:     boolean = false;
    isConsumption: boolean = false;
    hasBulkTag:    boolean = true;
    interactionTagLength: number = 0;
    submitted = false;
    selectedItem: any;
    form: UntypedFormGroup;
    isReadOnly: boolean = false;

    ngOnInit() {
        this.form = this.fb.group({
            'bulkInteractionTag': [null, Validators.compose([Validators.required, Validators.maxLength(25)])],
        });

        this.subscriptions.push(this.form.get('bulkInteractionTag').valueChanges.subscribe(bulkVal => {
            this.interactionTagLength = bulkVal.length;
        }));

        try {
            this.isSuperUser = this.claimsService.isSuperUser();
            this.isPayg = this.claimsService.hasPaygFeature();
            this.isPaygUpdate = this.claimsService.hasPaygUpdateFeature();
            this.isBilling = this.claimsService.hasBillingFeature();
            this.isConsumption = this.claimsService.hasConsumptionFeature();

            this.isReadOnly = !this.isSuperUser && !this.isPaygUpdate;
        } catch { }

        this.createOrUpdateNavList();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    createOrUpdateNavList() {
        if (this.navigationList.length == 0) {
            this.navigationList = [
                {
                    key: navItemKey.Account,
                    label: "Account",
                    items: [
                        {
                            key: BulkItemOptions.AdjustCreditStatus,
                            short: "ACS",
                            isGet: false,
                            selected: false

                        },
                        {
                            key: BulkItemOptions.ResetCreditStatus,
                            short: "RCS",
                            isGet: false,
                            isSkipHow: true,
                            selected: false
                        },
                        {
                            key: BulkItemOptions.ApplyLoan,
                            short: "AAL",
                            isGet: false,
                            selected: false
                        },
                        {
                            key: BulkItemOptions.ChangeECLimit,
                            short: "CVEC",
                            isGet: false,
                            selected: false
                        },
                        {
                            key: BulkItemOptions.GetCreditStatus,
                            short: "GCRS",
                            isGet: true,
                            selected: false
                        }
                    ]
                },
                {
                    key: navItemKey.TarrifConsumption,
                    label: "Tariff & Consumption",
                    items: [
                        {
                            key: BulkItemOptions.GetMeterReads,
                            short: "GMR",
                            isGet: true,
                            selected: false
                        },
                        {
                            key: BulkItemOptions.GetSupplyTarrifs,
                            short: "GST",
                            isGet: true,
                            selected: false
                        },
                        {
                            key: BulkItemOptions.UpdateSupplyTarrifs,
                            short: "UST",
                            isGet: false,
                            selected: false
                        },
                        {
                            key: BulkItemOptions.GetStandingCharges,
                            short: "GSC",
                            isGet: true,
                            selected: false
                        },
                        {
                            key: BulkItemOptions.UpdateStandingCharges,
                            short: "USC",
                            isGet: false,
                            selected: false
                        }
                    ]
                },
                {
                    key: navItemKey.Device,
                    label: "Device",
                    items: [
                        {
                            key: BulkItemOptions.GetFriendlyDisconnect,
                            short: "GFD",
                            isGet: true,
                            selected: false
                        },
                        {
                            key: BulkItemOptions.UpdateFriendlyDisconnectSettings,
                            short: "UFD",
                            isGet: false,
                            selected: false
                        },
                        {
                            key: BulkItemOptions.SendScreenMessage,
                            short: "SCM",
                            isGet: false,
                            selected: false
                        },
                        {
                            key: BulkItemOptions.GetConnectionStatus,
                            short: "GCS",
                            isGet: true,
                            selected: false
                        }
                    ]
                }
            ]
        }

        this.populateFromStorage();

        this.OptionItemList = this.getOptionItemList();
    }

    private getOptionItemList(): any[] {
        let items = this.navigationList.find(x => x.key == this.selectedNavItem).items;

        if (this.isReadOnly)
            items = items.filter(x => x.isGet == true);

        return items;
    }

    onInfoClick() {
        swal({
            title: 'Multi-device interaction tag',
            html: '<p style="text-align: left;">This tag allows you to identify the multi-device interaction in Device interactions, to track progress of the interactions.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }

    onTitleInfoClick() {
        swal({
            title: 'Select interaction type',
            html: '<p style="text-align: left;">Here you can select an interaction from the headers of: Account, Tariff & Consumption and Device, to then select when, who and how (where applicable).</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }

    changeNavItem(item: navItemKey) {
        this.storageService.removeItem("bulkInteractionInfo");
        this.selectedNavItem = item;

        this.OptionItemList.map(x => x.selected = false);
        this.form.get('bulkInteractionTag').setValue("");

        this.OptionItemList = this.getOptionItemList();
    }

    clickOptionitem(item: any) {
        this.storageService.removeItem("bulkInteractionInfo");

        this.OptionItemList.map(x => x.selected = false);
        item.selected = !item.selected;
        this.selectedItem = item;
        //set default tag

        let date = new Date();
        let year = (date.getFullYear() - 2000).toString();

        let fullDefaultBulkTag = year + this.addZero(date.getMonth()) + this.addZero(date.getDay()) + '_' + this.addZero(date.getHours()) + ':' + this.addZero(date.getMinutes()) + ':' + date.getSeconds() + '_' + item.short;

        this.form.get('bulkInteractionTag').setValue(fullDefaultBulkTag);
    }

    addZero(i) {
        i < 10 ? i = "0" + i : i;
        return i;
    }

    populateFromStorage() {
        //if storage has the interaction then pull from session storage
        if (this.multiDeviceInteractionService.getModelMultiDeviceModel && this.multiDeviceInteractionService.whatModel) {
            this.selectedNavItem = this.multiDeviceInteractionService.whatModel.navItem;
            this.OptionItemList = this.getOptionItemList();
            this.OptionItemList.find(y => y.key == this.multiDeviceInteractionService.whatModel.type.key).selected = true;

            this.form.get('bulkInteractionTag').setValue(this.multiDeviceInteractionService.whatModel.tag);
        }
    }

    submit(form: UntypedFormGroup) {
        this.submitted = true;
        if (!form.valid) return;

        let selectedOption = this.OptionItemList.find(x => x.selected == true);
        if (!selectedOption || selectedOption.length == 0) return;

        //check for only white space input
        let tag = form.controls.bulkInteractionTag.value;
        if (tag.replace(/ /g, '').length == 0) { this.hasBulkTag = false; return; }

        this.hasBulkTag = true;

        //assign model variables
        let whatModel = new InteractionTypeModel();
        whatModel.navItem = this.selectedNavItem;
        whatModel.tag = form.controls.bulkInteractionTag.value;

        // if user hasn't clicked on a button, get value from one currently selected
        if (!this.selectedItem) {
            this.selectedItem = this.OptionItemList.find(x => x.selected == true);
        }

        whatModel.isGet = this.selectedItem.isGet;
        whatModel.isSkipHow = this.selectedItem.isSkipHow;
        whatModel.type = selectedOption;

        this.multiDeviceInteractionService.whatModel = whatModel;

        let currentState = MultiDeviceInteractionState.what;
        let nextState = this.multiDeviceInteractionService.getNextState(currentState);

        this.router.navigated = false;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { state: nextState }
        });
    }
}
